import { ReactElement, useState } from 'react';
import { EyeInvisibleOutlined, EyeOutlined, LinkOutlined } from '@ant-design/icons';
import { Space } from 'antd';
import { useTranslation } from 'react-i18next';
import { Typography } from 'common/components/antd/Typography/Typography';
import { SContainer } from './TruncatedCopyableCell.style';
import { Tag } from '../antd/Tag/Tag';
import { Tooltip } from '../antd/Tooltip/Tooltip';
import { TruncateText } from '../Utilities/TruncateText';

type TruncatedCopyableTextCellProps = {
  children: any;
  rowIndex: number;
  onLinkClick?: (rowIndex: number) => void;
  length?: number;
  indicator?: string;
  truncateFn?: (text: string, length: number, indicator: string) => string;
  eyeVisiabilty?: boolean;
  linkTooltipText?: string;
};

export const TruncatedCopyableTextCell = ({
  children: text,
  rowIndex,
  onLinkClick,
  length = 12,
  indicator,
  truncateFn,
  eyeVisiabilty = true,
  linkTooltipText = '',
}: TruncatedCopyableTextCellProps): ReactElement => {
  const [truncated, setTruncated] = useState<boolean>(true);
  const [linkText, setLinkText] = useState<string>(linkTooltipText);
  const { t } = useTranslation();

  const onLinkIconClick = (): void => {
    if (onLinkClick) {
      setLinkText(t('common.copied') as string);
      onLinkClick(rowIndex);
      setTimeout(() => {
        setLinkText(linkTooltipText)
      }, 3000);
    }
  };

  return (
    text && (
      <SContainer>
        <Tag>
          <TruncateText truncateFn={truncateFn} indicator={indicator} length={truncated ? length : text.length}>
            {text.replace(/\s/g, '')}
          </TruncateText>
        </Tag>

        <Space
          style={{
            marginLeft: '8px',
          }}
        >
          <Typography.Text
            rootClassName="custom-ant-typography"
            copyable={{
              text,
              tooltips: [t('common.copy'), t('common.copied')]
            }}
          />
          {eyeVisiabilty && (
            <Typography.Text>
              {truncated ? (
                <EyeInvisibleOutlined
                  className="ant-typography-copy"
                  onClick={(): void => {
                    setTruncated(false);
                  }}
                />
              ) : (
                <EyeOutlined
                  className="ant-typography-copy"
                  onClick={(): void => {
                    setTruncated(true);
                  }}
                />
              )}
            </Typography.Text>
          )}
          {onLinkClick && (
            <Typography.Text>
              <Tooltip title={linkText} placement='top'>
                <LinkOutlined className="ant-typography-link" onClick={onLinkIconClick} />
              </Tooltip>
            </Typography.Text>
          )}
        </Space>
      </SContainer>
    )
  );
};
